import { IDashboardConfig } from '@/store/models/dashboard-config.model';
import { TAppError, IBaseAction, IBaseState } from '@/store/types/base.state';

export enum DashboadConfigActionTypes {
  GET_DASHBOARD_CONFIG = 'DASHBOARD_CONFIG.GET_DASHBOARD_CONFIG',
  GET_DASHBOARD_CONFIG_SUCCESS = 'DASHBOARD_CONFIG.GET_DASHBOARD_CONFIG_SUCCESS',
  GET_DASHBOARD_CONFIG_FAIL = 'DASHBOARD_CONFIG.GET_DASHBOARD_CONFIG_FAIL',
}

export interface IGetDashboardConfigAction extends IBaseAction {
  type: typeof DashboadConfigActionTypes.GET_DASHBOARD_CONFIG;
}

export interface IGetDashboardConfigSuccessAction extends IBaseAction {
  type: typeof DashboadConfigActionTypes.GET_DASHBOARD_CONFIG_SUCCESS;
  config?: IDashboardConfig;
}

export interface IGetDashboardConfigFailAction extends IBaseAction {
  type: typeof DashboadConfigActionTypes.GET_DASHBOARD_CONFIG_FAIL;
  error: TAppError;
}

export type TDashboardConfigAction =
  | IGetDashboardConfigAction
  | IGetDashboardConfigSuccessAction
  | IGetDashboardConfigFailAction;

export interface IDashboardConfigState extends IBaseState {
  config?: IDashboardConfig;
}
